import { RequestType } from '@Enums/requestType.enum';
import { type SendType, isEmdSendType } from '@Enums/sendType.enum';
import DocumentProtectGraphic from '@Assets/images/document-protect.svg?inline';
import ConfirmPhoneGraphic from '@Assets/images/confirm-phone.svg?inline';
import CollectPhoneGraphic from '@Assets/images/collect-phone.svg?inline';
import SecureSigningGraphic from '@Assets/images/secure-signing.svg?inline';
import IdentityPhoneGraphic from '@Assets/images/idv-welcome.svg?inline';

export interface WelcomeContent {
    headline: string;
    subheadline: string;
    imageSrc: string;
}

// DS-3309: a Send request can be an earnest money deposit (sendType === SendType.Emd).
// RequestType has no EMD value, so this variant is selected by sendType rather than
// the WELCOME_CONTENT_BY_REQUEST_TYPE map (see resolveWelcomeContent below).
export const SEND_EMD_WELCOME_CONTENT: WelcomeContent = {
    headline: 'Send your earnest money deposit.',
    subheadline: 'Safely and securely.',
    imageSrc: DocumentProtectGraphic,
};

export const WELCOME_CONTENT_BY_REQUEST_TYPE: Record<RequestType, WelcomeContent> = {
    [RequestType.Send]: {
        headline: 'Wire your closing funds.',
        subheadline: 'Safely and securely.',
        imageSrc: DocumentProtectGraphic,
    },
    [RequestType.Confirm]: {
        headline: 'Confirm your bank details.',
        subheadline: 'Safely and securely.',
        imageSrc: ConfirmPhoneGraphic,
    },
    [RequestType.Collect]: {
        headline: 'Share your bank details.',
        subheadline: 'Safely and securely.',
        imageSrc: CollectPhoneGraphic,
    },
    [RequestType.Identity]: {
        headline: 'Verify your identity.',
        subheadline: 'With confidence.',
        imageSrc: IdentityPhoneGraphic,
    },
    [RequestType.Unknown]: {
        headline: 'Complete your request.',
        subheadline: 'Safely and securely.',
        imageSrc: SecureSigningGraphic,
    },
};

// DS-3309: single home for welcome-content selection. EMD send requests get EMD copy;
// everything else keys off requestType. Keeps the two selection mechanisms (the map +
// the EMD special case) in one place instead of split across the view.
export function resolveWelcomeContent(
    requestType: RequestType,
    sendType: SendType | null | undefined,
): WelcomeContent {
    if (isEmdSendType(sendType)) return SEND_EMD_WELCOME_CONTENT;
    return WELCOME_CONTENT_BY_REQUEST_TYPE[requestType]
        ?? WELCOME_CONTENT_BY_REQUEST_TYPE[RequestType.Unknown];
}
